export default {
    /**
     * Closes "add to home screen" modal for apple
     */
    closeAddToHomeScreenModalForApple: async({ commit }) => {
        localStorage.setItem('addToHomeIosPromptLastDate', Date.now());
        commit('setShowAddToHomeScreenModalForApple', false);
    },
};